import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {IconButton} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import {useDispatch} from "react-redux";
import {setIsAuthenticated} from "../../../business/redux/reducers/auth/actions";
import {useNavigate} from "react-router-dom";
export const RightMenuSection = ({toggleDrawerRightMenu, open}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const {logout, loginWithRedirect} = useAuth0();

    const handleLogout = () => {
        // logout().then(e => loginWithRedirect)
        sessionStorage.setItem("authenticated", "false");
        dispatch(setIsAuthenticated(false))
        navigate('/')
    }

    return (
        <Drawer
            open={open}
            onClose={toggleDrawerRightMenu(false)}
            anchor="right"
            PaperProps={{
                sx: {
                    height:'max-content',
                    top: 60,
                    right: 10,
                }
            }}
        >
            <Box sx={{width: 180, display:'flex',alignItems:'center', justifyContent: 'center'}} role="presentation" onClick={toggleDrawerRightMenu(false)}>
                <IconButton onClick={handleLogout} sx={{fontSize:'14px',borderRadius:'0',width:'100%',color:'red',textTransform:'uppercase',letterSpacing:'1px'}}>
                    <LogoutIcon sx={{mr:1}}/> Logout
                </IconButton>
            </Box>
        </Drawer>
    );
}